document.addEventListener( "DOMContentLoaded", () => {
  const sections = document.querySelectorAll( ".bw-slider" );

  sections.forEach( ( section ) => {
    const slider = section.querySelector( ".slider" );
    const controlsContainer = section.querySelector( ".slider-controls" );

    if ( !slider || !controlsContainer ) return;

    const sliderInstance = tns( {
      container: slider,
      items: 1.15,
      slideBy: 1,
      autoplay: false,
      nav: false,
      loop: false,
      gutter: 16,
      controlsContainer: controlsContainer,
      autoplayButtonOutput: false,
      responsive: {
        1024: {
          items: 3,
          gutter: 24,
          fixedWidth: false,
        }
      }
    } );
  } );
} );
